import React from 'react';
import styled, { css } from 'styled-components';
import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { ForecastIconLoadingUI } from '../common/forecastIconLoadingUI';
import { WeatherDetailsLoadingUI } from './weatherDetailsLoadingUI';

export const MobileDayCardListItemLoadingUI = () => {
    return (
        <Container>
            <DayNightSectionsWrapper>
                <CardDaySection key='mobile-card-day-section'>
                    <CardSectionIconWrapper>
                        <ForecastIconLoadingUI />
                    </CardSectionIconWrapper>
                    <WeatherDetailsLoadingUI isNight={false} />
                    <TemperatureReading>
                        <AnimatedLoadingPlaceholder height='100%' />
                    </TemperatureReading>
                </CardDaySection>
                <CardNightSection key='mobile-card-night-section'>
                    <CardSectionIconWrapper>
                        <ForecastIconLoadingUI />
                    </CardSectionIconWrapper>
                    <WeatherDetailsLoadingUI isNight={true} />
                    <TemperatureReading>
                        <AnimatedLoadingPlaceholder height='100%' />
                    </TemperatureReading>
                </CardNightSection>
            </DayNightSectionsWrapper>
        </Container>
    );
};

const Container = styled.li`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    margin-bottom: 5px;
`;

const DayNightSectionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    max-height: 120px;
    width: 100%;
    justify-content: center;
`;

const DayNightSectionStyles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    width: 100%;
    height: 60px;
    white-space: nowrap;
    font-size: 0;
    padding: 5px 10px;
`;

const CardDaySection = styled.div`
    ${DayNightSectionStyles}
    background-color: #f9f9f9;
`;

const CardNightSection = styled.div`
    ${DayNightSectionStyles}
    background-color: #eeeeee;
`;

const CardSectionIconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
`;

const TemperatureReading = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 40px;
    height: 25px;
`;